var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataEmr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1321318490"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34625834",
    width: 60,
    height: 60,
    rx: 30,
    fill: "#EFF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1612",
    d: "M46.9108 24.6354C46.9108 36.3885 30.0003 44.6332 30.0003 44.6332C30.0003 44.6332 13.0898 36.8686 13.0898 24.6354C13.0898 12.8828 30.0003 11.6827 30.0003 24.6352C30.0003 11.6827 46.9108 12.8823 46.9108 24.6354Z",
    stroke: "#121212",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2735",
    d: "M9.74609 32.6176H23.8445L25.0585 28.2413L29.047 38.605L32.3418 24.1309L34.7696 32.6176H50.2552",
    stroke: "#6587FF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataEmr);
export default __webpack_public_path__ + "static/media/data-emr.568008d568f4358e33f99da1cc9c9d22.svg";
export { ForwardRef as ReactComponent };